
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skigebiet",
      function () {
        return require("private-next-pages/skigebiet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skigebiet"])
      });
    }
  